import React, { Component } from "react";
import {
    Modal
} from "antd";

class GenericOnClickModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false
        };
    }

    showModal = () => {
        let newState = { ...this.state };
        newState["showModal"] = true;
        this.setState(newState);
    };

    handleCancelModal = () => {
        let newState = { ...this.state };
        newState["showModal"] = false;
        this.setState(newState);
    };

    render() {
        const widthMap = {
            sm: 300,
            md: 600,
            lg: 900,
            xl: 1200,
        };
        return (
            <>
                <a onClick={this.showModal}>
                    {this.props.button}
                </a>

                <Modal
                    footer={this.props.modalFooter || null}
                    width={widthMap[this.props.size]}
                    title={this.props.modalTitle}
                    visible={this.state.showModal}
                    onCancel={this.handleCancelModal}
                >
                    {this.props.modalBody}
                </Modal>
            </>
        );
    }
}

export default GenericOnClickModal;
